import { render } from "./Prezentare.vue?vue&type=template&id=626af079"
import script from "./Prezentare.vue?vue&type=script&lang=js"
export * from "./Prezentare.vue?vue&type=script&lang=js"

import "./Prezentare.vue?vue&type=style&index=0&id=626af079&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__